import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { getRerunBulkUpdateData } from "store/siteRepo/actionCreator";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";

const RerunBulkUpdate = ({ productsData, setProductsData }) => {
  const dispatch = useDispatch();
  const { siteId } = useParams();
  const { rerunBulkUpdateData } = useSelector((state) => state.siteRepo);
  const [alreadyProcessed, setAlreadyProcessed] = useState(false);
  useEffect(() => {
    dispatch(getRerunBulkUpdateData(siteId));
  }, [siteId]);

  const handleRerunBulkUpdate = () => {
    if (rerunBulkUpdateData?.length && !alreadyProcessed) {
      var isreRunBulkUpdate = false;
      let tempArr = JSON.parse(JSON.stringify(productsData));
      tempArr.forEach((element) => {
        rerunBulkUpdateData.forEach((item) => {
          if (
            ((!element.salesNumber && !item.oldSalesNo) || element.salesNumber === item.oldSalesNo) &&
            element.id.trim() === item.oldProdName.trim() &&
            element.type === item.oldProdType
          ) {
            element.newProductId = item.newProdName;
            element.newType = item.newProdType;
            element.newSalesNumber = item.newSalesNo;
            element.newCategoryCode = item.newCategoryCode;
            if (item.laborCodeChangeLogDataList) {
              item.laborCodeChangeLogDataList?.forEach((labor) => {
                let tempLaborCodes = {
                  description: labor.laborCodeModDescription ?? labor.laborCodeDescription,
                  descriptionExt: labor.laborCodeDescriptionExt,
                  id: labor.laborCodeId,
                  laborCode: labor.laborCode,
                  isTaxable: labor.laborCodeIsTaxable,
                };

                var contains = element.laborCodesArr.some((elem) => {
                  return JSON.stringify(tempLaborCodes) === JSON.stringify(elem);
                });
                if (!contains) {
                  element.laborCodesArr.push(tempLaborCodes);
                }
              });
            } else {
              element.laborCodesArr = [];
            }
            element.selectedLaborCodes = element.laborCodesArr.map(({ laborCode }) => laborCode);
            isreRunBulkUpdate = true;
          }
        });
      });
      rerunBulkUpdateData.forEach((item) => {
        if (!item.oldSalesNo && !item.oldProdName && item.newProdName) {
          let element = {};
          element.newProductId = item.newProdName;
          element.newType = item.newProdType;
          element.newSalesNumber = item.newSalesNo;
          element.newCategoryCode = item.newCategoryCode;

          element.id = item.newProdName;
          element.type = item.newProdType;
          element.salesNumber = item.newSalesNo;
          element.categoryCode = item.newCategoryCode;

          element.actualUsage = "0";
          element.isManualProduct = true;
          element.laborCodesArr = item.laborCodeChangeLogDataList?.map((labor) => ({
            description: labor.laborCodeModDescription ?? labor.laborCodeDescription,
            descriptionExt: labor.laborCodeDescriptionExt,
            id: labor.laborCodeId,
            laborCode: labor.laborCode,
          }));
          isreRunBulkUpdate = true;
          tempArr.push(element);
        }
      });

      if (!isreRunBulkUpdate) {
        toast.error("No products matching the prior bulk update found.");
      }
      setProductsData(tempArr);
      setAlreadyProcessed(true);
    }
  };

  if (rerunBulkUpdateData?.length > 0) {
    return (
      <Button variant="outline-primary" onClick={handleRerunBulkUpdate} disabled={alreadyProcessed}>
        Rerun Bulk Update
      </Button>
    );
  }
};

export default RerunBulkUpdate;
